import { type FC } from 'react';
import {
  CornersOut
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconCornersOutProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconCornersOut: FC<UiIconCornersOutProps> = (props) => {
  return (
    <UiIcon
      IconComponent={CornersOut}
      {...props}
    />
  );
};
